type UserWithIds = {
	id: string;
};

const findById = <User extends UserWithIds>(users: User[], idToFind: string) => {
	return users.find((users) => users.id === idToFind);
};

const findFirstTwoUsersInIds = <User extends UserWithIds>(users: User[], ids: string[]) => {
	const [firstId, secondId] = ids;
	if (!firstId) return {};

	const firstSelectedUser = findById(users, firstId);
	const secondSelectedUser = findById(users, secondId);

	return {
		firstSelectedUser,
		secondSelectedUser,
	};
};

export { findFirstTwoUsersInIds };
